export default __webpack_public_path__ + "static/media/keynote10.bbde7aa9.jpeg";